<script>
export default {
  name: "SwitchButton",
  functional: true,
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, showButton, isCheck,  cssName, isIFTT, showLabel, showCheckBox, checkBoxValue,hideCheckBox} = props;
    const $t = parent.$t;
    const click = listeners.click;
    const changeCheckBox = listeners.changeCheckBox;
    if (!children[0].tag) {
      children = null;
    }
    const className = `common_active_div`
    const className1 = `active_joinTool ${cssName} ${showButton && cssName ? 'left_fill_jionTool' : ''}`
    const className2 = `scence_ctr_span_title switch_button_title`
    const className3 = `switch_button `
    const className4 = `joinTool ${showButton && cssName ? 'joinTool_sloid' : ''}`
    const className5 = `triggle_line ${showCheckBox && checkBoxValue ? 'triggle_cur' : ''} ${hideCheckBox? 'hideCheckBox': ''}`
    return (
      <div class={className3}>
        {showCheckBox && <div class={className5}>
          <em
            class="triggle_more triggle_more_action"
            onClick={()=>changeCheckBox && changeCheckBox(checkBoxValue)}
        />
        </div>}
        {showLabel && <div class={className2}>{name}</div>}
        {(children || showButton) &&
          <div class={className}>
            <div class={className1}>
              {children}
            </div>
            {showButton &&
              <div class={className4}>
                <button class={'button_light ' + (isCheck ? 'joinSelected' : '')} onClick={() => click && click(true)} style={`margin: 0 10px 0 ${children ? '10px' : 0};`}>{$t('sceneCard.joinYes')}</button>
                <button class={'button_light ' + (!isCheck ? 'joinSelected' : '')} onClick={() => click && click(false)}>{$t('sceneCard.joinNo')}</button>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";

.arrow-down-only {
  margin-top: 10px;
}

.switch_button_title {
  margin-top: 3px;
}
.hideCheckBox .triggle_more_action{
  visibility: hidden;
}

</style>
